import {
    getRenewalSegmentCount,
    getRenewalAggrementCount,
    getRenewalFlagsCount,
    getCurrentDashboard,
    getTodaysRenewalHttp,
    getTodaysRenewalGroupedHttp,
    getMonthlyRevenueHttp,
    getTopCustomersRevenueHttp,
    getMonthlyRenewalCountHttp,
    getExtensionDatesHttp // Fixed: Added missing import
} from "../../../http/renewalHttp/RenewalHttp";
import { getRenewalTeamDomainCount } from "../../../http/renewalHttp/RenewalMemberHttp";
import Div from "../../../components/Div";
import RenewalTeam from "../../../components/Dashboards/RenewalTeam";
import { useEffect, useState, useCallback } from "react";
import Input from "../../../components/Input";

export default function RenewalDashboard() {
    const [teamDomain, setTeamDomain] = useState(false);
    const [segmentCount, setSegmentCount] = useState(false);
    const [aggrementCount, setAggrementCount] = useState(false);
    const [flagsCount, setFlagsCount] = useState(false);
    const [currentDashboard, setCurrentDashboard] = useState(false);
    const [totalTodayCount, setTotalTodayCount] = useState(0);
    const [todaysRenewal, setTodaysRenewal] = useState(false);
    const [monthlyRevenue, setMonthlyRevenue] = useState(0);
    const [topCustomers, setTopCustomers] = useState(false);
    const [monthlyRenewalCount, setMonthlyRenewalCount] = useState(0);
    const [extensionData, setExtensionData] = useState(false);

    const getCurrentYearMonth = () => {
        const date = new Date();
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
    };

    const [month, setMonth] = useState(getCurrentYearMonth);

    const formatCurrencyShort = (value) => {
        if (!value || isNaN(value)) return "₹0";
        if (value >= 10000000) return "₹" + (value / 10000000).toFixed(2) + " Cr";
        if (value >= 100000) return "₹" + (value / 100000).toFixed(2) + " L";
        return "₹" + new Intl.NumberFormat('en-IN').format(Math.floor(value));
    };

 const getTodaysData = useCallback(async () => {
    try {
        const response = await getTodaysRenewalGroupedHttp(); 
        if (response && response.renewals) {
            const total = response.renewals.reduce((acc, curr) => acc + curr.domain_count, 0);
            setTotalTodayCount(total);

            const columns = (
                <>
                    <th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Assigned Member</th>
                    <th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Domain Count</th>
                </>
            );
            // Set data and use tag='today'
            setTodaysRenewal({ data: response.renewals, columns: columns });
        }
    } catch (error) { console.log(error); }
}, []);

    const getTeamData = useCallback(async () => {
        try {
            const response = await getRenewalTeamDomainCount(month);
            const columns = (<><th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Team Member Email</th>
                <th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Domain Count</th></>);
            setTeamDomain({ data: response.domains, columns: columns, month: month });
        } catch (error) { console.log(error); }
    }, [month]);

    const getSegmentCountData = useCallback(async () => {
        try {
            const response = await getRenewalSegmentCount(month);
            const columns = (<><th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Segments</th>
                <th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Count</th></>);
            setSegmentCount({ data: response.segments, columns: columns });
        } catch (error) { console.log(error); }
    }, [month]);

    const getAggrementCountData = useCallback(async () => {
        try {
            const response = await getRenewalAggrementCount(month);
            const columns = (<><th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Aggrement Status</th>
                <th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Count</th></>);
            setAggrementCount({ data: response.aggrements, columns: columns });
        } catch (error) { console.log(error); }
    }, [month]);

    const getFlagStatusCoutData = useCallback(async () => {
        try {
            const response = await getRenewalFlagsCount(month);
            const columns = (<><th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Flag Status</th>
                <th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Count</th></>);
            setFlagsCount({ data: response.flags, columns: columns });
        } catch (error) { console.log(error); }
    }, [month]);

    const getCurrentDashboardData = useCallback(async () => {
        try {
            const response = await getCurrentDashboard(month);
            const columns = (<><th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Monthly</th>
                <th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Count</th></>);
            setCurrentDashboard({ data: response.flags, columns: columns });
        } catch (error) { console.log(error); }
    }, [month]);

    const getRevenueData = useCallback(async () => {
        try {
            const res = await getMonthlyRevenueHttp(month);
            if (res) setMonthlyRevenue(res.revenue);
        } catch (error) { console.log(error); }
    }, [month]);

    const getTopCustomersData = useCallback(async () => {
        try {
            const response = await getTopCustomersRevenueHttp(month);
            if (response && response.top_customers) {
                const columns = (
                    <>
                        <th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Customer Domain</th>
                        <th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Total Revenue</th>
                    </>
                );
                setTopCustomers({ data: response.top_customers, columns: columns });
            }
        } catch (error) { console.log(error); }
    }, [month]);

    const getMonthlyCountData = useCallback(async () => {
        try {
            const res = await getMonthlyRenewalCountHttp(month);
            if (res) setMonthlyRenewalCount(res.total_count);
        } catch (error) { console.log(error); }
    }, [month]);

    const getExtensionData = useCallback(async () => {
        try {
            const response = await getExtensionDatesHttp(month);
            if (response && response.extensions) {
                const columns = (
                    <>
                        <th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Domain</th>
                        <th style={{ position: "sticky", top: 0, backgroundColor: "#f1f1f1", zIndex: 100 }}>Extension Date</th>
                    </>
                );
                setExtensionData({ data: response.extensions, columns: columns });
            }
        } catch (error) { console.error(error); }
    }, [month]);

    useEffect(() => {
        getTeamData(); getAggrementCountData(); getSegmentCountData();
        getFlagStatusCoutData(); getCurrentDashboardData(); getTodaysData();
        getRevenueData(); getTopCustomersData(); getMonthlyCountData(); getExtensionData();
    }, [getTeamData, getAggrementCountData, getSegmentCountData, getFlagStatusCoutData, getCurrentDashboardData, getTodaysData, getRevenueData, getTopCustomersData, getMonthlyCountData, getExtensionData]);

    const tableStyle = {
        width: "100%",
        height: "450px",
        border: "1px solid #ddd",
        borderRadius: "10px",
        padding: "15px",
        backgroundColor: "#fff",
        boxShadow: "0px 2px 4px rgba(0,0,0,0.05)"
    };

    return (
        <Div className="container-fluid p-4">
            {/* Header Row: Month Picker & Scorecards */}
            <Div className="row align-items-center mb-4">
                <Div className="col-md-3">
                    <label className="fw-bold mb-1 small">Filter Month</label>
                    <Input type='month' value={month} onChange={(e) => setMonth(e.target.value)} />
                </Div>
                <Div className="col-md-3">
                    <div className="card shadow-sm p-1" style={{ borderLeft: '4px solid #007bff', height: '65px', display: 'flex', justifyContent: 'center' }}>
                        <div className="d-flex justify-content-between align-items-center px-2">
                            <span className="text-muted fw-bold small">Today's Count</span>
                            <h3 className="mb-0 text-primary">{totalTodayCount}</h3>
                        </div>
                    </div>
                </Div>

                <Div className="col-md-3">
                    <div className="card shadow-sm p-2" style={{ borderLeft: '4px solid #28a745', minHeight: '65px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <div className="d-flex justify-content-between align-items-start px-2">
                            <span className="text-muted fw-bold small">Monthly Revenue</span>
                            <div className="text-end">
                                <h4 className="mb-0 text-success fw-bold">{formatCurrencyShort(monthlyRevenue)}</h4>
                                <div className="text-muted" style={{ fontSize: '10px', marginTop: '-2px' }}>
                                    ₹{new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(monthlyRevenue)}
                                </div>
                            </div>
                        </div>
                    </div>
                </Div>

                <Div className="col-md-3">
                    <div className="card shadow-sm p-1" style={{ borderLeft: '4px solid #ffc107', height: '65px', display: 'flex', justifyContent: 'center' }}>
                        <div className="d-flex justify-content-between align-items-center px-2">
                            <span className="text-muted fw-bold small">Monthly Renewal</span>
                            <h3 className="mb-0 text-warning">{monthlyRenewalCount}</h3>
                        </div>
                    </div>
                </Div>
            </Div>

            {/* Grid Row 1: Extensions & Top Customers */}
            <Div className="row mb-4">
                <Div className="col-md-6 mb-3">
                    <Div style={tableStyle}>
                        <RenewalTeam title='Monthly Dashboard' data={currentDashboard.data} columns={currentDashboard.columns} tag='current' />
                    </Div>
                </Div>
                
                <Div className="col-md-6 mb-3">
                    <Div style={tableStyle}>
                        <RenewalTeam
                            title="Top 100 Customers by Revenue"
                            data={topCustomers.data}
                            columns={topCustomers.columns}
                            tag='top_customers'
                        />
                    </Div>
                </Div>
            </Div>

            {/* Grid Row 2: Today's Renewals & Team Domain */}
            <Div className="row mb-4">
                <Div className="col-md-6 mb-3">
                    <Div style={tableStyle}>
                        <RenewalTeam title="Today's Renewals" data={todaysRenewal.data} columns={todaysRenewal.columns} tag='today' />
                    </Div>
                </Div>
                <Div className="col-md-6 mb-3">
                    <Div style={tableStyle}>
                        <RenewalTeam title='Renewal Team Domain' data={teamDomain.data} columns={teamDomain.columns} selectedMonth={teamDomain.month} tag='team' />
                    </Div>
                </Div>
            </Div>

            {/* Grid Row 3: Segments & Agreements */}
            <Div className="row mb-4">
                <Div className="col-md-6 mb-3">
                    <Div style={tableStyle}>
                        <RenewalTeam title='Segment Dashboard' data={segmentCount.data} columns={segmentCount.columns} tag='segments' />
                    </Div>
                </Div>
                <Div className="col-md-6 mb-3">
                    <Div style={tableStyle}>
                        <RenewalTeam title='Aggrement Status' data={aggrementCount.data} columns={aggrementCount.columns} tag='aggrements' />
                    </Div>
                </Div>
            </Div>

            {/* Grid Row 4: Flags & Monthly Dashboard */}
            <Div className="row mb-4">
                <Div className="col-md-6 mb-3">
                    <Div style={tableStyle}>
                        <RenewalTeam title='Flag Status' data={flagsCount.data} columns={flagsCount.columns} tag='flags' />
                    </Div>
                </Div>
                
                <Div className="col-md-6 mb-3">
                    <Div style={tableStyle}>
                        <RenewalTeam 
                            title="Extension Dates" 
                            data={extensionData.data} 
                            columns={extensionData.columns} 
                            tag='extensions' 
                        />
                    </Div>
                </Div>
            </Div>
        </Div>
    );
}